import "@/App.css";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Reel from "@/components/Reel";
import Gallery from "@/components/Gallery";
import Credits from "@/components/Credits";
import Resume from "@/components/Resume";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
  return (
    <div className="App bg-[#0A0A0C] text-white min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Reel />
        <Gallery />
        <Credits />
        <Resume />
        <Contact />
      </main>
      <Footer />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#121215",
            color: "#F2F2F2",
            border: "1px solid rgba(255,255,255,0.08)",
            borderRadius: 0,
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
